/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Current_PlanInputs */

const en_current_plan = /** @type {(inputs: Current_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Current Plan:`)
};

const es_current_plan = /** @type {(inputs: Current_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plan actual:`)
};

const fr_current_plan = /** @type {(inputs: Current_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forfait actuel :`)
};

const de_current_plan = /** @type {(inputs: Current_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktueller Plan:`)
};

const ja_current_plan = /** @type {(inputs: Current_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`現在のプラン:`)
};

const zh_current_plan = /** @type {(inputs: Current_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`当前套餐：`)
};

const ar_current_plan = /** @type {(inputs: Current_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الخطة الحالية:`)
};

const id_current_plan = /** @type {(inputs: Current_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paket Saat Ini:`)
};

const it_current_plan = /** @type {(inputs: Current_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Piano Attuale:`)
};

const ru_current_plan = /** @type {(inputs: Current_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Текущий тариф:`)
};

const pt_current_plan = /** @type {(inputs: Current_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plano Atual:`)
};

const ko_current_plan = /** @type {(inputs: Current_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`현재 요금제:`)
};

/**
* | output |
* | --- |
* | "Current Plan:" |
*
* @param {Current_PlanInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const current_plan = /** @type {((inputs?: Current_PlanInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Current_PlanInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_current_plan(inputs)
	if (locale === "es") return es_current_plan(inputs)
	if (locale === "fr") return fr_current_plan(inputs)
	if (locale === "de") return de_current_plan(inputs)
	if (locale === "ja") return ja_current_plan(inputs)
	if (locale === "zh") return zh_current_plan(inputs)
	if (locale === "ar") return ar_current_plan(inputs)
	if (locale === "id") return id_current_plan(inputs)
	if (locale === "it") return it_current_plan(inputs)
	if (locale === "ru") return ru_current_plan(inputs)
	if (locale === "pt") return pt_current_plan(inputs)
	return ko_current_plan(inputs)
});